<template>
  <div class="card">
    <div class="card-body">
      <router-link
        class="close"
        :to="'/' + 'products/' + $i18n.locale"
      ></router-link>
      <h5 class="create-title">{{ $t('addNewProdCat') }}</h5>
      <form @submit.prevent="createProductCategory">
        <p class="inputLabel">{{ $t('experienceCat') }}</p>
        <input
          class="field"
          v-model="experienceCategory.name"
          type="text"
          maxlength="30"
          :placeholder="$t('expCatNameExample')"
          :class="{ 'error-boarder': $v.experienceCategory.name.$error }"
          @blur="$v.experienceCategory.name.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.experienceCategory.name.$error">
          <p v-if="!$v.experienceCategory.name.required" class="errorMessage">
            {{ $t('expCatReq') }}
          </p>
        </template>
        <template v-if="$v.experienceCategory.name.$error">
          <p v-if="!$v.experienceCategory.name.maxLength" class="errorMessage">
            {{ $t('catNameMaxLength') }}
          </p>
        </template>
        <p class="inputLabel">{{ $t('tagline') }}</p>
        <b-form-textarea
          class="field"
          v-model="experienceCategory.hero_tagline"
          :state="experienceCategory.hero_tagline.length <= 40"
          type="text"
          :placeholder="$t('taglineExpExample')"
          :class="{ 'error-boarder': $v.experienceCategory.hero_tagline.$error }"
          @blur="$v.experienceCategory.hero_tagline.$touch()"
        ></b-form-textarea>
        <span class="comment">*{{ $t('taglineVisible') }}</span>
        <!--Form validation-->
        <template v-if="$v.experienceCategory.hero_tagline.$error">
          <br />
          <p
            v-if="!$v.experienceCategory.hero_tagline.required"
            class="errorMessage"
          >
            {{ $t('taglineReq') }}
          </p>
        </template>
        <template v-if="$v.experienceCategory.hero_tagline.$error">
          <p v-if="!$v.experienceCategory.hero_tagline.maxLength" class="errorMessage">
            {{ $t('descMaxLength') }}
          </p>
        </template>

        <!-- <coverUpload /> -->
        <!---<input type="submit" class="button -fill-gradient" value="Submit" /> -->
        <p v-if="$v.anyError" class="errorMessage">
          {{ $t('fillInReq') }}
        </p>
        <div enctype="multipart/form-data" novalidate>
          <h3>{{ $t('addcover') }}</h3>
          <div class="tipWrapper">
            <div class="help-tip">
              <p>
                {{ $t('proposedDim') }}: <strong>1500x1500 px</strong><br />
                {{ $t('proposedFormate') }}: <strong>.jpg</strong><br />
                {{ $t('proposedSize') }}: <strong>0.3Mb</strong>
              </p>
            </div>
          </div>
          <div class="dropbox">
            <input
              ref="coverImage"
              type="file"
              name="file"
              :disabled="isSaving"
              @change="filesChange($event.target.name, $event.target.files)"
              accept="image/*"
              class="input-file"
            />

            <p>
              {{ $t('uploadInstuctions1') }}<br />
              {{ $t('uploadInstuctions2') }}
            </p>
            <p v-if="isSaving">
              {{ $t('uploading') }}
            </p>
            <img
              v-if="imageBlob"
              :src="imageBlob"
              class="img-responsive img-thumbnail"
              alt="No image found"
            />
          </div>
        </div>
        <button
          type="submit"
          class="add-btn"
          :disabled="$v.$invalid"
          >{{ $t('add') }}
        </button>
      </form>
      <div v-if="isFailed">
        <h2>Uploaded failed.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Try again</a>
        </p>
        <!-- <pre>{{ uploadError }}</pre> -->
      </div>
      <sweet-modal icon="success" ref="modalSuccess">
        {{ $t('addedExpCatConf') }}
      </sweet-modal>
      <sweet-modal icon="error" title="Oh nooo…" ref="modalError">
        {{ $t('errorMsg') }}
        <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import NProgress from 'nprogress'
// import coverUpload from '@/components/ui/coverUpload.vue'
import { upload } from '@/services/prodImgUpload.service.js'
import { required, maxLength } from 'vuelidate/lib/validators'
import constants from '@/utils/Constants.js'
import { SweetModal } from 'sweet-modal-vue'

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3

export default {
  components: {
    // coverUpload
    SweetModal
  },
  data() {
    return {
      type: null,
      experienceCategory: this.createFreshExperienceCategoryObject(),
      formData: new FormData(),
      imageBlob: null,
      currentStatus: null,
    }
  },
  validations: {
    experienceCategory: {
      name: { required, maxLength: maxLength(18) },
      hero_tagline: { required, maxLength: maxLength(40) },
    },
  },
  methods: {
    createProductCategory() {
      // this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        this.$store
          .dispatch(
            'experience/createExperienceCategory',
            this.experienceCategory
          )
          .then((response) => {
            // this.$router.push({ name: 'product-category-list' }) // automatically redirect to login when user click "register"//
            if (!this.firstProductCreate) {
              this.$refs.modalSuccess.open()
              this.$router.push({
                name: 'product-list'
              })
            }
            // })    //ERROR: posting in db.json OK, routing at submit click NOT WORKING //
            else {
              if(this.$refs.coverImage.files.length > 0) {
                this.save(this.formData, response.id)
              } else {
                this.$refs.modalSuccess.open()
                this.$emit('success-category', {})
              }
            }
            // this.experienceCategory = this.createFreshExperienceCategoryObject()
          })
          .catch((err) => {
            this.errors = err.response.data.errors
            this.$refs.modalError.open()
          })
          .catch(() => {
            NProgress.done()
          })
      }
    },
    createFreshExperienceCategoryObject() {
      const client = this.$store.state.client.client
      const id = Math.floor(Math.random() * 1000000)

      return {
        id: id,
        client: client,
        name: '',
        hero_tagline: '',
      }
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      this.imageBlob = null
      this.formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        this.imageBlob = URL.createObjectURL(fileList[x])
        this.formData.append(fieldName, fileList[x], fileList[x].name)
      })
    },
    save(formData, catId) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      var paramsJson = {
        expCat_id: catId,
        type: constants.EXP_COVER_IMAGE,
      }
      upload(formData, paramsJson)
        .then((x) => {
          this.$refs.modalSuccess.open()
          this.currentStatus = STATUS_SUCCESS
          this.$emit('success-category', x)
        })
        .catch((err) => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    },
  },
  props: {
    firstProductCreate: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.field {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-bottom: 1em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: rgba(44, 62, 80, 0.2);
  color: dimgray;
  padding: 10px 10px;
  position: relative;
  width: 400px;
  height: auto;
  cursor: pointer;
}
.container {
  display: inline-block;
  width: 60%;
  margin: 0;
  padding: 0;
}

.add-btn {
  margin-top: 1em;
  background: var(--primaryDark);
  color: var(--bright);
  letter-spacing: 8px;
  border-radius: 5px;
  width: 200px;
  text-transform: uppercase;
  padding: 15px;
  font-size: 1.6em;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}


.error-boarder {
  border: 2px solid var(--primaryDark);
}

form {
  padding: 0;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  left: 0;
  height: 100%;
  position: absolute;
  cursor: pointer;
}
/*** TOOL TIP CSS ***/
.tipWrapper {
  position: relative;
}

.help-tip {
  position: absolute;
  bottom: 10px;
  right: 5px;
  text-align: center;
  background-color: var(--grey-Dark);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 26px;
  cursor: default;
  z-index: 3;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover {
  cursor: pointer;
  background-color: #ccc;
}

.help-tip:before {
  content: '?';
  font-weight: 700;
  color: #fff;
}

.help-tip p {
  visibility: hidden;
  opacity: 0;
  text-align: left;
  background-color: var(--grey-Dark);
  padding: 20px;
  width: 300px;
  position: absolute;
  border-radius: 4px;
  right: -4px;
  color: #fff;
  font-size: 13px;
  line-height: 1.2rem;
  transform: scale(0.7);
  transform-origin: 100% 0%;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}
.help-tip:active p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}

.help-tip p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: var(--grey-Dark);
  right: 10px;
  top: -12px;
}

.help-tip p:after {
  width: 100%;
  height: 40px;
  content: '';
  position: absolute;
  top: -5px;
  left: 0;
}

.help-tip a {
  color: #fff;
  font-weight: 700;
}

.help-tip a:hover,
a:active .help-tip a:focus {
  color: #fff;
  text-decoration: underline;
}
// end of question tooltip//

.dropbox:hover {
  background: rgba(
    185,
    123,
    66,
    0.4
  ); /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

@media screen and (min-width: 1351px) {
  .dropbox {
    width: 300px;
    margin: auto;
  }
}
@media screen and (max-width: 1350px) {
  .dropbox {
    width: 350px;
  }
}

@media screen and (max-width: 1200px) {
  .dropbox {
    width: 300px;
  }
}

@media screen and (max-width: 500px) {
  form {
    width: 100%;
  }
  .container {
    width: 100%;
  }
  .dropbox {
    width: 100%;
  }
  textarea {
    width: 100% !important;
    height: 70px;
  }
  .add-btn {
  margin-top: 50px;
  width: 100%;
  letter-spacing: 6px;
  padding: 10px;
  font-size: 1.5em;
}
}

form {
  width: 45%;
}

.fullWidth {
  width: 100% !important;
}
.left {
  margin-bottom: 0px;
}

.left input {
  margin: 10px 0px;
}

.create-title {
  font-weight: 600;
  font-size: 2.5em;
  margin-top: 20px;
}

.card-body {
  color: #454655;
}
.comment {
  font-size: 0.7rem;
  text-align: left;
  margin-top: -20px;
  display: block;
  padding-top: 0;
}
.field {
  margin-bottom: 24px;
}
.inputLabel {
  text-align: left;
  margin-bottom: 0px;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

.card-title {
  font-size: 30px;
}
p {
  text-align: left;
}
.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}

@media screen and (min-width: 560px) {
  .close {
    display: none;
  }
}

@media screen and (max-width: 560px) {
  form {
    width: 100%;
    padding: 10px;
  }
 .create-title {
  font-size: 1.8em;
  margin-top: 60px;
  margin-bottom: 20px;
}
}
</style>
